import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3016a535"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "description" }
const _hoisted_3 = { class: "intro-step" }
const _hoisted_4 = { class: "card-step" }
const _hoisted_5 = { class: "steps-title" }
const _hoisted_6 = { class: "step-by-step" }
const _hoisted_7 = { class: "step-by-step" }
const _hoisted_8 = { class: "text-button-refactor" }

import BackButton from "@/components/BackButton.vue";
import { Codemirror } from "vue-codemirror";
import ButtonPopup from "../components/ButtonPopup.vue";
import { onBeforeRouteUpdate, useRoute, useRouter } from "vue-router";
import { java } from "@codemirror/lang-java";
import { useExerciseStore } from "@/stores/exerciseStore";
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExercisePage',
  setup(__props) {

const { t } = useI18n();

const language = [java()];
const router = useRouter();
const route = useRoute();
let id = Number(route.params.idSmell);
let idSmell = Number(route.params.id);

const exerciseStore = useExerciseStore();

exerciseStore.fetchExercise(id);

onBeforeRouteUpdate(async (to, from) => {
  if (to.params.id !== from.params.id) {
    id = Number(to.params.id);
    await exerciseStore.fetchExercise(id);
  }
});

function handleChange(value: string) {
  exerciseStore.refactorState = false;
  exerciseStore.userExercise = value;
}

function checkIfNeedsPasso(passo: string) {
  const trimmedPasso = passo.trim();
  if (/^\d+/.test(trimmedPasso)) {
    return exerciseStore.stepKeyword;
  }
  return "";
}

function handleRefactor() {
  if (exerciseStore.checkRefactor()) {
    exerciseStore.feedback = true;
  } else {
    exerciseStore.feedback = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "container"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "back-button" }, {
            default: _withCtx(() => [
              _createVNode(BackButton, {
                onclick: () => _unref(router).push(`/chooseexercise/${_unref(idSmell)}`)
              }, null, 8, ["onclick"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { class: "header" }, {
            default: _withCtx(() => [
              _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(exerciseStore).title), 1),
              _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(exerciseStore).description), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Codemirror), {
                "model-value": _unref(exerciseStore).exerciseChoose,
                class: "code-editor",
                onChange: _cache[0] || (_cache[0] = (value) => handleChange(value)),
                extensions: language
              }, null, 8, ["model-value"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { align: "center" }, {
                default: _withCtx(() => [
                  _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(t)('exercisePage.introStep')), 1),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(t)('exercisePage.stepsTitle')), 1),
                    _createElementVNode("ul", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(exerciseStore).formatedSteps, (step) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: step,
                          class: _normalizeClass(checkIfNeedsPasso(step) ? 'step' : '')
                        }, _toDisplayString(checkIfNeedsPasso(step) + step), 3))
                      }), 128))
                    ]),
                    _createElementVNode("ul", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(exerciseStore).formatedAsserts, (assert) => {
                        return (_openBlock(), _createElementBlock("p", {
                          class: "step-assert",
                          key: assert
                        }, _toDisplayString(_unref(exerciseStore).assertionKeyword + assert), 1))
                      }), 128))
                    ])
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("h2", _hoisted_8, _toDisplayString(_unref(t)('exercisePage.refactorText')), 1),
              _createVNode(_component_v_row, {
                class: "foot-buttons",
                justify: "space-around"
              }, {
                default: _withCtx(() => [
                  _createVNode(ButtonPopup, {
                    text: _unref(t)('exercisePage.refactor'),
                    disable: _unref(exerciseStore).refactorState,
                    onclick: handleRefactor,
                    refactor: _unref(exerciseStore).feedback
                  }, null, 8, ["text", "disable", "refactor"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})